import axios from "axios";
import { FlagProjectsReportSummary, FlagProjectsReportDetail } from "./models/ReportModels";

declare const window: Window & { configuration: { apiUrl: string } };

export const getCostCenterValidationReports = async (): Promise<FlagProjectsReportSummary[]> => {
    const { data } = await axios.get<FlagProjectsReportSummary[]>(
        `${window.configuration.apiUrl}api/admin/reports/cost-center-validation`
    );
    return data;
};

export const getCostCenterValidationReportDetail = async (id: number): Promise<FlagProjectsReportDetail> => {
    const { data } = await axios.get<FlagProjectsReportDetail>(
        `${window.configuration.apiUrl}api/admin/reports/cost-center-validation/${id}`
    );
    return data;
};
